import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';

const LoginPage = lazy(() =>
	import('./LoginPage').then(({ LoginPage }) => ({ default: LoginPage }))
);
const LogoutPage = lazy(() =>
	import('./LogoutPage').then(({ LogoutPage }) => ({ default: LogoutPage }))
);

export const getAuthRoutes = (): RouteObject[] => [
	{ path: getPagePartSlug('prihlaseni'), element: <LoginPage /> },
	{ path: getPagePartSlug('odhlaseni'), element: <LogoutPage /> },
];
